// SP-14857 - Début de nom répété dans une liste de sous-comptes : le nom du parent
// (« Flannerie - Interne » pour « Flannerie - Interne - Enfant test ») ou les mots
// communs aux voisins (« Kisio - CRC » pour « Kisio - CRC Dijon », « Kisio - CRC Aix »).

const siblingsPrefix = (names) => {
  if (names.length < 2) {
    return '';
  }

  const [first, ...others] = names.map((name) => name.split(' '));
  const firstDifferent = first.findIndex((word, i) => others.some((words) => i >= words.length - 1 || words[i] !== word));
  const count = firstDifferent === -1 ? first.length - 1 : firstDifferent;

  return count > 0 ? `${first.slice(0, count).join(' ')} ` : '';
};

export function sharedNamePrefix(names, parentName) {
  const fromParent = parentName && names.every((name) => name.startsWith(`${parentName} `)) ? `${parentName} ` : '';
  const fromSiblings = siblingsPrefix(names);

  return fromParent.length > fromSiblings.length ? fromParent : fromSiblings;
}

// Le séparateur qui suit le préfixe (« - ») est estompé avec lui ; jamais le nom entier.
// Le premier mot (`lead`) reste visible : seule la suite du préfixe se tronque.
export function splitName(name, prefix) {
  const end = prefix.length + name.slice(prefix.length).match(/^[\s\-–—:/|>]*/)[0].length;
  if (end === 0 || end >= name.length) {
    return { lead: '', prefix: '', rest: name };
  }

  const shared = name.slice(0, end);
  const lead = shared.match(/^\s*\S*\s*/)[0];

  return { lead, prefix: shared.slice(lead.length), rest: name.slice(end) };
}
